module.exports = __webpack_public_path__ + "b23897903e3de4c34bba1e5246cc5e75.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000016T6.png
// module id = 1661
// module chunks = 0